export enum ClientApps {
  ClubHub = 'ClubHub',
  LenderHub = 'LenderHub',
  UserManager = 'UserManager',
}
